
import viewData from './viewData.js'
// import cache from '../cache.js'

// import DROPDOWN_LISTS from '../../components/DropdownLists.json'

// const CACHE_PATH_DATA = ['schoolYear', 'data']
// const CACHE_TIME = 15 * 60 * 1000 // 15 minutes

const _vars = {
  data: undefined
}

function populate(data) {
  // cache.set(data, CACHE_TIME, ...CACHE_PATH_DATA)
  _vars.data = data
}

function getSync(id) {
  if (_vars.data === undefined) {
    return undefined
  }
  return _vars.data.find(elem => elem.code === id)
}

function get(id) {
  // cache.checkGetMiss(CACHE_PATH_DATA, () => {
  //   return viewData.getOptionsFromServer()
  // })
  let retPromise = undefined
  if (_vars.data === undefined) {
    _vars.viewPromise = viewData.getOptionsFromServer()

    retPromise = _vars.viewPromise.then(() => {
      return _vars.data.find(elem => elem.code === id)
    })
  }
  else {
    retPromise = Promise.resolve(getSync(id))
  }
  return retPromise
}

function filter(filterIds) {
  let retPromise = undefined
  if (_vars.data === undefined) {    
    _vars.viewPromise = viewData.getOptionsFromServer()

    retPromise = _vars.viewPromise.then(() => {
      return _vars.data.filter(elem => filterIds.includes(elem.code))
    })
  }
  else {
    retPromise = Promise.resolve(_vars.data.filter(elem => filterIds.includes(elem.code)))
  }
  return retPromise
}

export default {
  populate: populate,
  getSync: getSync,
  get: get,
  filter: filter,
}

